import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import React, { useContext, useState } from "react";
import { EtlContext } from "./EtlContext";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export const ETLTruncateButton = () => {
    const etlContext = useContext(EtlContext);
    const [modalOpen, setModalOpen] = useState(false);

    const truncate: () => Promise<void> = async () => {
        setModalOpen(false);
        
        try {
            etlContext.runTruncate();
            await new Promise(resolve => setTimeout(resolve, 2000));
            await etlContext.updateHistory();
        } catch (e) {
            console.log(e);
        };
    };

    return <>
        <AlertDialog open={modalOpen} setOpen={setModalOpen} onProceed={truncate} />
        <Button
            component="label"
            variant="contained"
            disabled={etlContext.status !== 'Rest'}
            tabIndex={-1}
            startIcon={<DeleteForeverIcon />}
            onClick={() => setModalOpen(true)}
            sx={{
                backgroundColor: 'black'
            }}
        >
            Truncate MySQL table
        </Button >
    </>
};

const AlertDialog: React.FC<{ open: boolean, setOpen: React.Dispatch<React.SetStateAction<boolean>>, onProceed: () => Promise<void> }> = ({ open, setOpen, onProceed }) => {
    return <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {"Are you sure?"}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This will permanently delete data on your MySQL table.
                <br />
                Please proceed with caution, and make sure the data has been successfully transported to another source before erasing it.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={() => onProceed()} autoFocus>
                Truncate table
            </Button>
        </DialogActions>
    </Dialog>


}